'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = require('ramda');

var MENU_WIDTH = 180;

var styles = {
  wrap: {
    minHeight: '100%'
  },
  menuBtn: {
    padding: 15,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer'
  },
  menuBtnBar: {
    background: '#000',
    width: 15,
    height: 2,
    borderRadius: 1,
    marginBottom: 3
  },
  menu: function menu(_ref) {
    var topLevel = _ref.topLevel;

    return {
      fontFamily: '"Lucida Grande", Helvetica, arial, sans-serif',
      marginLeft: 6,
      paddingLeft: 4
    };
  },
  menuWrap: function menuWrap(_ref2) {
    var fullWidth = _ref2.fullWidth;
    var menuOpen = _ref2.menuOpen;

    return {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: fullWidth && !menuOpen ? -MENU_WIDTH : 0,
      width: MENU_WIDTH,
      background: '#f5f5f5',
      borderRight: 'solid 1px #ddd',
      boxSizing: 'border-box',
      padding: '20px 10px',
      overflow: 'auto',
      transition: 'left .25s',
      zIndex: 1000
    };
  },
  node: {
    padding: '0 0'
  },
  nodeName: {
    margin: '2px 0',
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: 'bold',
    color: '#000'
  },
  leaf: function leaf(_ref3) {
    var current = _ref3.current;

    return {
      display: 'block',
      textDecoration: 'none',
      color: 'black',
      fontSize: '12px',
      lineHeight: '20px',
      margin: '2px 0',
      textDecoration: current ? 'underline' : 'none'
    };
  },
  content: function content(_ref4) {
    var fullWidth = _ref4.fullWidth;

    return {
      marginLeft: fullWidth ? 0 : MENU_WIDTH,
      padding: fullWidth ? '10px 0' : 10
    };
  }
};

function locationCutHead(item) {
  return _extends({}, item, { location: _ramda.tail(item.location) });
}

function isLeaf(item) {
  return item.location.length === 1;
}

function isNode(item) {
  return item.location.length > 1;
}

function node(children) {
  return {
    type: 'node',
    name: children[0].location[0],
    children: toTree(children.map(locationCutHead))
  };
}

function leaf(item) {
  return {
    type: 'leaf',
    name: item.location[0],
    hash: item.hash
  };
}

function groupToTree(group) {
  var children = group.filter(isNode);
  return group.filter(isLeaf).map(leaf).concat(children.length > 0 ? [node(children)] : []);
}

function toTree(arr) {
  return _ramda.unnest(_ramda.values(_ramda.groupBy(function (item) {
    return item.location[0];
  }, arr)).map(groupToTree));
}

var MenuNode = function MenuNode(props) {
  return _react2['default'].createElement(
    'div',
    { style: styles.node },
    _react2['default'].createElement(
      'div',
      { style: styles.nodeName },
      props.name
    ),
    _react2['default'].createElement(Menu, { items: props.children, current: props.current })
  );
};

var MenuLeaf = function MenuLeaf(props) {
  return _react2['default'].createElement(
    'a',
    {
      href: '#!' + props.hash,
      style: styles.leaf({ current: props.current === props.hash })
    },
    props.name
  );
};

var Menu = function Menu(props) {
  return _react2['default'].createElement(
    'div',
    { style: styles.menu({ topLevel: props.topLevel }) },
    props.items.map(function (item, i) {
      return item.type === 'leaf' ? _react2['default'].createElement(MenuLeaf, _extends({}, item, { current: props.current, key: i })) : _react2['default'].createElement(MenuNode, _extends({}, item, { current: props.current, key: i }));
    })
  );
};

exports['default'] = _createReactClass2['default']({

  propTypes: {
    menu: _propTypes2['default'].arrayOf(_propTypes2['default'].object.isRequired).isRequired,
    children: _propTypes2['default'].node,
    fullWidth: _propTypes2['default'].bool,
    currentHash: _propTypes2['default'].string
  },

  getInitialState: function getInitialState() {
    return {
      menuOpen: false
    };
  },

  handleMenuBtnClick: function handleMenuBtnClick() {
    this.setState({ menuOpen: true });
  },

  handleWrapClick: function handleWrapClick(e) {
    if (e.target === this.refs.menuBtn || e.target.parentNode === this.refs.menuBtn) {
      return;
    }
    this.setState({ menuOpen: false });
  },

  render: function render() {
    var _props = this.props;
    var menu = _props.menu;
    var children = _props.children;
    var fullWidth = _props.fullWidth;
    var currentHash = _props.currentHash;
    var menuOpen = this.state.menuOpen;

    return _react2['default'].createElement(
      'div',
      { onClick: this.handleWrapClick, style: styles.wrap },
      fullWidth && _react2['default'].createElement(
        'button',
        { onClick: this.handleMenuBtnClick, ref: 'menuBtn', style: styles.menuBtn },
        _react2['default'].createElement('div', { style: styles.menuBtnBar }),
        _react2['default'].createElement('div', { style: styles.menuBtnBar }),
        _react2['default'].createElement('div', { style: styles.menuBtnBar })
      ),
      _react2['default'].createElement(
        'div',
        { style: styles.menuWrap({ fullWidth: fullWidth, menuOpen: menuOpen }) },
        _react2['default'].createElement(Menu, { items: toTree(menu), topLevel: true, current: currentHash })
      ),
      _react2['default'].createElement(
        'div',
        { style: styles.content({ fullWidth: fullWidth }), key: currentHash },
        children
      )
    );
  }

});
module.exports = exports['default'];